import getElevatedJitaAccessLink from '../utils/getElevatedJitaAccessLink';
import { useTranslation } from './useNavConfig';
const useAccountAlertData = ({
  scopes,
  userEmail,
  accountName
}) => {
  const {
    t
  } = useTranslation();
  const hasElevatedJitaAccessScope = scopes.includes('nav-elevated-jita-access');
  const hasElevatedJitaActiveScope = scopes.includes('nav-elevated-jita-active');
  const elevatedJitaAccessLink = getElevatedJitaAccessLink(userEmail, accountName, scopes);
  if (hasElevatedJitaAccessScope && !hasElevatedJitaActiveScope) {
    return {
      level: 'info',
      title: t('nav.alerts.jitaDefault.title'),
      linkText: t('nav.alerts.jitaDefault.description'),
      link: elevatedJitaAccessLink
    };
  }
  return undefined;
};
export default useAccountAlertData;